module.exports = __webpack_public_path__ + "img/logo-dashboard-header-dark.61e40b2e.png";